import { Doughnut } from "vue-chartjs";
import merge from "lodash/merge";
import Chart from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";
import "chartjs-adapter-moment";
import { APP_COLORS } from "@/config/app-colors";

const defaultColors = {
  primary: APP_COLORS.PRIMARY,
  orange: "#f0a801",
  moodyBlue: "#4a4f66",
  pink: "#E91E63"
};

export default {
  name: "DoughnutChart",
  extends: Doughnut,
  props: {
    data: {
      type: Array,
      default: () => []
    },
    colors: {
      type: Array,
      default: () => [
        defaultColors.primary,
        defaultColors.orange,
        defaultColors.moodyBlue,
        defaultColors.pink
      ]
    },
    labels: {
      type: Array,
      default: () => []
    },
    options: {
      type: Object,
      default: () => {}
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      doughnutChartDefaultOptions: {
        animation: {
          animateScale: true
        },
        cutoutPercentage: 70,
        legend: {
          display: false
        }
      }
    };
  },
  beforeCreate() {
    Chart.plugins.unregister(ChartDataLabels);
  },
  mounted() {
    this.$emit("loadingChartStatus", true);
    this.render();
  },
  watch: {
    labels: function() {
      this.render();
      this.$emit("loadingChartStatus", false);
    },
    data: function() {
      this.render();
      this.$emit("loadingChartStatus", false);
    }
  },
  methods: {
    render() {
      this.renderChart(
        {
          labels: this.labels,
          datasets: [
            {
              data: this.data,
              backgroundColor: this.colors
            }
          ]
        },
        merge(this.doughnutChartDefaultOptions, this.options)
      );
    }
  }
};
